import React from 'react'
import {
    StyledHeader,
    StyledSubText,
    TWStayInformedContent,
    TWStayInformedBlockContainer,
    TWAppDownloadWidgetContainer,
} from './TWStayInformedBlock.styled'
import { TWAppDownloadWidget } from '../TWAppDownloadWidget/TWAppDownloadWidget'

export const TWStayInformedBlock = () => {
    return (
        <TWStayInformedBlockContainer>
            <TWStayInformedContent>
                <StyledHeader>
                    {/* Using non-breaking spaces to prevent line breaks in "The West app" */}
                    Stay informed with The&nbsp;West&nbsp;app
                </StyledHeader>
                <StyledSubText>
                    The No. 1 source of news for
                    every&nbsp;West&nbsp;Australian.
                </StyledSubText>
            </TWStayInformedContent>
            <TWAppDownloadWidgetContainer>
                <TWAppDownloadWidget inverseButton={true} />
            </TWAppDownloadWidgetContainer>
        </TWStayInformedBlockContainer>
    )
}
